import React from 'react';
import Text from 'src/components/Text';
import Button from 'src/components/Button';
import routes from 'src/constants/routes';
import useAuthorization from 'src/dataHooks/useAuthorization';
import { useNavigate } from 'src/utils/useNavigate';
import styles from './styles.module.scss';

const RaiffeisenBank: React.FC = () => {
  const navigate = useNavigate();
  
  const { authorizationState } = useAuthorization();
  
  const handleBack = () => {
    navigate(authorizationState?.userId ? routes.agent : routes.main);
  };
  
  const handleEnableService = () => {
    window.open('https://www.rbo.raiffeisen.ru/sign-form', '_blank');
  }
  
  return (
    <div>
      <Text type="h3">Для клиентов Райффайзен Банка</Text>
      <ol className={styles['list']}>
        <li>
          <Text type="p">
            Заполните{' '}
            <a
              href="https://www.rbo.raiffeisen.ru/sign-form"
              target="_blank"
              className={styles['link']}
            >
              анкету
            </a>
            {' '}в онлайн-банке. В поле «Вы работаете через Агента ТСП?» укажите ИНФОРАС (1С)
          </Text>
        </li>
        <li>
          <Text type="p">
            Получите токен в{' '}
            <a
              href="https://sbp.1c.ru/ui?customization=Raiffeisen"
              target="_blank"
              className={styles['link']}
            >
              Агенте 1С:СБП
            </a>
            {' '}и настройте интеграцию
          </Text>
        </li>
      </ol>
      <Button
        width="available"
        onClick={handleEnableService}
        className={styles['button']}
      >
        Подключить СБП за 5 минут
      </Button>
      <Button
        variant="outlined"
        width="available"
        onClick={handleBack}
        className={styles['button']}
      >
        Назад
      </Button>
    </div>
  );
};

export default RaiffeisenBank;
